import Text from "../../shared/text/Text";
import ZIcon from "../../shared/ZIcon/ZIcon";
import styles from "./ClaimOwnershipModal.module.scss";

const WRAPPERSTYLES = {
  blue: {
    filled: styles.blueFilledContainer,
  },
};

const MessageTitle = ({ messageConfig }) => {
  const { theme, variant, title, icon } = messageConfig ?? {};

  return (
    <div
      className={`${styles.messageTileWrapper} ${WRAPPERSTYLES[theme]?.[variant]}`}
    >
      {icon && (
        <div className={styles.messageTileIconWrapper}>
          <ZIcon unicode={icon} className={styles.messageTileIcon} />
        </div>
      )}
      {title && <Text uiData={title} />}
    </div>
  );
};

export default MessageTitle;
